import React, { useState } from 'react';
import treeList from './treeList';
import First from './First';

const BoatAdminTree = ({ value = [], onChange = () => {}, disabled }) => {
  const handleValue = (ary = []) => {
    ary.forEach(t => {
      const i = value.indexOf(t);
      if (i > -1)value.splice(i, 1);
      else value.push(t);
    });
    onChange(value);
  };
  return (
    <div style={{ display: 'flex', flex: 1, marginRight: 50 }}>
      {treeList.map((ary = [], i) => (
        <div key={i} style={{ flex: 1 }}>
          {ary.map((o, i2) => (
            <First key={i2} data={o} value={value} onChange={handleValue} disabled={disabled} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default BoatAdminTree;
